import { gql } from '@apollo/client';

export const ROTATIONSPLAENE_BY_STANDORT_IDS = gql(`
  query mitarbeiter_rotationsplaeneByStandortIds($standortIds: [String!]!) {
   mitarbeiter_rotationsplaeneByStandortIds(standortIds: $standortIds){
      id
      standortId
      mitarbeiter {
        id
        bildUrl
        vorname
        nachname
        arbeitsbereich {
          id
          markierung
          name
          standort {
            id
            name
            storenummer
          }
        }
        standort {
          id
          name
          storenummer
        }
      }
      beruf {
        id
        abkuerzung
        name
        markierung
        istAusbildung
      }
      abschnitte {
        id
        name
        position
        stationen {
            __typename
            ... on mitarbeiter_rotationsplanArbeitsbereichStation {
                id
                von
                bis
                lernziele
                arbeitsbereich {
                  name
                  id
                  markierung
                  standort {
                    id
                    name
                    storenummer
                  } 
                    
                }
                bereichsleiter {
                    id
                    bildUrl
                    vorname
                    nachname
                }
            }
            ... on mitarbeiter_rotationsplanAbwesenheitsStation {
              id
              von
              bis
              name
            }
        }
      }
    }
}
`);
